// src/pages/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }) {
  const token = localStorage.getItem('token'); // check if user is logged in
  return token ? children : <Navigate to="/login" replace />;
}
